import { useMissionStore } from '../../../shared/store/useMissionStore';
import { useChapterStore } from '../../../shared/store/useChapterStore';
import { Card } from '../card';
import { useMemo } from 'react';

export const NextPart = () => {
  const nextChapter = useChapterStore((state) => state.nextChapter);
  const chapterPage = useChapterStore((state) => state.chapterPage);
  const mission = useMissionStore((state) => state.mission);

  const chapterIndex = useMemo(() => {
    return mission?.chapters?.findIndex((c) => c?.uuid === nextChapter?.uuid) ?? 0;
  }, [mission?.chapters, nextChapter?.uuid]);

  if (!nextChapter || !mission || !chapterPage) return null;

  return (
    <div className="mb-6 grid">
      <h3 className="mb-4 font-cadiz text-sh-28-32 font-bold">{chapterPage.nextPart}</h3>
      <div className="grid md:grid-cols-2">
        <Card
          key={nextChapter.uuid}
          chapterId={nextChapter.uuid as string}
          chapter={nextChapter}
          missionSlug={mission.slug}
          index={chapterIndex}
          trait={mission?.trait}
          totalChapters={mission?.chapters?.length || 0}
        />
      </div>
    </div>
  );
};
